import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  makeStyles,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { sanlamIndigo } from 'Material-UI/colors';

const useStyles = makeStyles({
  root: {
    borderRadius: 8,
    backgroundColor: '#FFFFFF',
    boxShadow: '0 1px 3px 0 rgba(0,0,0,0.25)',
    margin: '0px !important',
  },
  expandIcon: {
    color: sanlamIndigo,
  },
  AccordionSummaryRoot: {
    height: 55,
  },
  AccordionDetailsRoot: {
    maxHeight: 195,
    overflowY: 'auto',
    scrollbarColor: '#9797AF #F7F7F7',
    padding: 0,
    marginBottom: 24,
  },
});

const CustomizedAccordion: React.FC<{
  details: React.ReactNode;
  summary: React.ReactNode;
  expanded: boolean;
  changeHandler: (event: React.ChangeEvent<{}>, expanded: boolean) => void;
}> = ({ details, summary, expanded, changeHandler }) => {
  const classes = useStyles();
  return (
    <Accordion
      data-testid="accordion"
      expanded={expanded}
      onChange={changeHandler}
      classes={{ root: classes.root }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        classes={{
          expandIcon: classes.expandIcon,
          root: classes.AccordionSummaryRoot,
        }}
      >
        {summary}
      </AccordionSummary>
      <AccordionDetails classes={{ root: classes.AccordionDetailsRoot }}>
        {details}
      </AccordionDetails>
    </Accordion>
  );
};

export default CustomizedAccordion;
